import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PayTrackerApp from './paytracker/PayTrackerApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isPayTrackerRoute = window.location.pathname.replace(/\/+$/, '') === '/pay-tracker';

root.render(
  <React.StrictMode>
    {isPayTrackerRoute ? <PayTrackerApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
